// ─────────────────────────────────────────────────────────────────────────
// Pipeline actions — the fixed choices shown when a sales person taps a
// button on a lead card (Log Call, Log Demo, Won, Lost ...).
//
// To change a choice, edit ONLY this file. Each choice says:
//   label      – text the sales person sees
//   nextStage  – stage the lead moves to (null = stays where it is)
//   task       – the next follow-up task { title, days } (null = none)
//   askDate    – true = sales person picks the follow-up date
//   lostReason – saved as the "Reason Lost" when the lead goes to Lost
// ─────────────────────────────────────────────────────────────────────────

// Today + n days, as YYYY-MM-DD in the user's own local time.
export const dateInDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

const CALL = {
  title: "Log Call",
  choices: [
    { id: "spoke_demo", label: "Spoke — wants a demo", nextStage: "Contacted", task: { title: "Schedule demo with", days: 2 } },
    { id: "spoke_later", label: "Spoke — call back later", nextStage: null, task: { title: "Call again:", days: 2 } },
    { id: "no_answer", label: "No answer", nextStage: null, task: { title: "Call again:", days: 1 } },
    { id: "not_decider", label: "Spoke to someone else (not the decision maker)", nextStage: null, task: { title: "Call the President or Secretary of", days: 2 } },
    { id: "send_details", label: "Asked me to send details", nextStage: null, task: { title: "Send details (WhatsApp / email) to", days: 1 } },
    { id: "committee", label: "Committee meeting needed first", nextStage: "Contacted", askDate: true, task: { title: "Follow up after committee meeting with", days: 7 } },
    { id: "invalid", label: "Wrong number / invalid contact", nextStage: "Lost", lostReason: "Invalid contact", task: null },
    { id: "not_interested", label: "Not interested", nextStage: "Lost", lostReason: "Not interested", task: null },
  ],
};

const DEMO = {
  title: "Log Demo",
  choices: [
    { id: "demo_interested", label: "Demo done — interested", nextStage: "Meeting/Demo", task: { title: "Follow up on demo with", days: 2 } },
    { id: "demo_time", label: "Demo done — needs time", nextStage: "Meeting/Demo", task: { title: "Follow up on demo with", days: 5 } },
    { id: "demo_trial", label: "Wants a trial", nextStage: "Meeting/Demo", task: { title: "Set up trial for", days: 2 } },
    { id: "demo_proposal", label: "Wants a proposal", nextStage: "Proposal Sent", task: { title: "Send proposal to", days: 1 } },
    { id: "demo_no", label: "Demo done — not interested", nextStage: "Lost", lostReason: "Not interested after demo", task: null },
  ],
};

const PROPOSAL = {
  title: "Log Follow-up",
  choices: [
    { id: "prop_negotiating", label: "Negotiating", nextStage: "Negotiation", task: { title: "Follow up on negotiation with", days: 3 } },
    { id: "prop_waiting", label: "Waiting for their decision", nextStage: null, task: { title: "Follow up on proposal with", days: 3 } },
    { id: "prop_no", label: "Not interested", nextStage: "Lost", lostReason: "Not interested after proposal", task: null },
  ],
};

const WON = {
  title: "Deal Won",
  choices: [
    { id: "won", label: "Deal won", nextStage: "Won", task: { title: "Run Setup Wizard for", days: 1 } },
  ],
};

const LOST = {
  title: "Deal Lost — why?",
  choices: [
    { id: "lost_price", label: "Price too high", nextStage: "Lost", lostReason: "Price too high", task: null },
    { id: "lost_other", label: "Chose another product", nextStage: "Lost", lostReason: "Chose another product", task: null },
    { id: "lost_noresp", label: "No response", nextStage: "Lost", lostReason: "No response", task: null },
    { id: "lost_notneeded", label: "Not needed", nextStage: "Lost", lostReason: "Not needed", task: null },
  ],
};

// Buttons shown on the lead card, per stage. tone: "won" / "lost" get colours.
export const STAGE_BUTTONS = {
  "New Lead": [{ label: "📞 Log Call", action: CALL }],
  "Contacted": [
    { label: "📞 Log Call", action: CALL },
    { label: "🖥️ Log Demo", action: DEMO },
  ],
  "Meeting/Demo": [
    { label: "🖥️ Log Demo", action: DEMO },
    { label: "✅ Won", action: WON, tone: "won" },
    { label: "❌ Lost", action: LOST, tone: "lost" },
  ],
  "Proposal Sent": [{ label: "💬 Log Follow-up", action: PROPOSAL }],
  "Negotiation": [
    { label: "✅ Won", action: WON, tone: "won" },
    { label: "❌ Lost", action: LOST, tone: "lost" },
  ],
};
